import React from 'react'
import {FaGithub} from 'react-icons/fa'

const HeaderRight = () => {
    return (
        <div className="header_socialsRight">
            <a href="https://github.com/SlimPapii"    target="_blank" rel="noopener noreferrer"><FaGithub/></a>
        </div>
    )
}

export default HeaderRight